import styled from 'styled-components';
import { CardTitle } from '../../../../components/ManagementCardGrid';

export const TitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const ClickableTitle = styled(CardTitle)`
  cursor: pointer;
`;

export const TypeBadgeRow = styled.div`
  margin-top: 4px;
`;

export const TypeBadge = styled.span`
  display: inline-block;
  padding: 2px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  background-color: ${({ $bg }) => $bg};
  color: ${({ $color }) => $color};
`;
